import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import PropertyPostSystemMenuIcon from "./PropertyPostSystemMenuIcon";
import PropertyPlatformPostMenuIcon from "./PropertyPlatformPostMenuIcon";
import FacebookWhiteIcon from "../../../../components/icons/FacebookWhiteIcon";
import FacebookIcon from "../../../../components/icons/FacebookIcon";
import InstagramWhiteIcon from "../../../../components/icons/InstagramWhiteIcon";
import InstagramIcon from "../../../../components/icons/InstagramIcon";
import GoogleBusinessWhiteIcon from "../../../../components/icons/GoogleBusinessWhiteIcon";
import GoogleBusinessIcon from "../../../../components/icons/GoogleBusinessIcon";
import LinkedInWhiteIcon from "../../../../components/icons/LinkedInWhiteIcon";
import LinkedInIcon from "../../../../components/icons/LinkedInIcon";
import TikTokWhiteIcon from "../../../../components/icons/TikTokWhiteIcon";
import TikTokIcon from "../../../../components/icons/TikTokIcon";
import YouTubeWhiteIcon from "../../../../components/icons/YouTubeWhiteIcon";
import YouTubeIcon from "../../../../components/icons/YouTubeIcon";
import TrueIcon from "../../../../components/icons/TrueIcon";
import LockIcon2 from "../../../../components/icons/LockIcon2";
import SocialMediaWarningIcon from "../../../../components/icons/SocialMediaWarningIcon";

const PLATFORMS = [
  {
    key: "Facebook",
    label: "Facebook",
    ActiveIcon: FacebookWhiteIcon,
    InactiveIcon: FacebookIcon,
  },
  {
    key: "Instagram",
    label: "Instagram",
    ActiveIcon: InstagramWhiteIcon,
    InactiveIcon: InstagramIcon,
  },
  {
    key: "google_business",
    label: "Google Business",
    ActiveIcon: GoogleBusinessWhiteIcon,
    InactiveIcon: GoogleBusinessIcon,
  },
  {
    key: "LinkedIn",
    label: "LinkedIn",
    ActiveIcon: LinkedInWhiteIcon,
    InactiveIcon: LinkedInIcon,
  },
];

const LOCKED_PLATFORMS = [
  {
    key: "TikTok",
    label: "TikTok",
    ActiveIcon: TikTokWhiteIcon,
    InactiveIcon: TikTokIcon,
  },
  {
    key: "YouTube",
    label: "YouTube",
    ActiveIcon: YouTubeWhiteIcon,
    InactiveIcon: YouTubeIcon,
  },
];

const PostHeader = ({
  propertyPostId,
  propertyPost,
  updating,
  getStageLabel,
  CommonHelpers,
  onPostNow,
  onSchedulePost,
  onUpdated,
  activeTab,
  setActiveTab,
  selectedPlatforms,
  togglePlatformSelected,
  activePlatformKey,
  activePlatformLabel,
  statusConfig,
  platformScheduledFor,
  openPlatformPostNow,
  openPlatformSchedule,
  handlePlatformCancelSchedule,
  platformData,
  connectedPlatforms = {},
  onPlatformNotConnectedClick,
}) => {
  const platformCheckRefs = useRef({});

  const [localSelected, setLocalSelected] = useState({ ...selectedPlatforms });

  useEffect(() => {
    setLocalSelected({ ...selectedPlatforms });

    Object.keys(selectedPlatforms).forEach((key) => {
      const el = platformCheckRefs.current[key];
      if (el) {
        if (selectedPlatforms[key]) {
          el.classList.add("checked");
        } else {
          el.classList.remove("checked");
        }
      }
    });
  }, [selectedPlatforms]);

  const handlePlatformToggle = (platformKey, event) => {
    event.stopPropagation();

    setLocalSelected((prev) => ({
      ...prev,
      [platformKey]: !prev[platformKey],
    }));

    const el = platformCheckRefs.current[platformKey];
    if (el) {
      const nextState = !localSelected[platformKey];
      if (nextState) {
        el.classList.add("checked");
      } else {
        el.classList.remove("checked");
      }
    }

    togglePlatformSelected(platformKey);
  };

  const isActivePlatformConnected = connectedPlatforms?.[activeTab] === true;

  console.log("activeTab:", activeTab);
  console.log("connectedPlatforms:", connectedPlatforms);
  console.log(
    "connectedPlatforms[activeTab]:",
    connectedPlatforms?.[activeTab],
  );
  console.log("isActivePlatformConnected:", isActivePlatformConnected);

  return (
    <div className="post-config-wrapper">
      <div className="post-config-top">
        <div className="post-config-heading">
          <div className="post-config-title">Post system</div>
          <div className="post-config-subtitle">
            A controlled system that generates, structures, and distributes
            every property post across platforms.
          </div>
        </div>

        <PropertyPostSystemMenuIcon
          postId={propertyPostId || ""}
          currentStatus={propertyPost?.post_status}
          disabled={updating}
          onPostNow={onPostNow}
          onSchedulePost={onSchedulePost}
          onUpdated={onUpdated}
        />
      </div>

      <div className="post-info-header">
        <div className="info-item">
          <span className="label">Property Stage</span>
          <span className="value">
            {propertyPost?.template_label || getStageLabel}
          </span>
        </div>

        <div className="info-item">
          <span className="label">Property</span>
          <span className="value property-link">
            <a href={`/properties/view/${propertyPost?.property_id?._id}`}>
              {CommonHelpers.getPropertyAddress({
                unit: propertyPost?.property_id?.unit,
                no: propertyPost?.property_id?.property_no,
                streetName:
                  propertyPost?.property_id?.property_no_and_street_name,
                city: propertyPost?.property_id?.city,
                state: propertyPost?.property_id?.state,
                postCode: propertyPost?.property_id?.post_code,
                country: propertyPost?.property_id?.country,
              })}
            </a>
          </span>
        </div>
      </div>

      <div className="platform-scroll">
        <div className="platform-list">
          {PLATFORMS.map(({ key, label, ActiveIcon, InactiveIcon }) => {
            const isActive = activeTab === key;
            const isChecked = !!localSelected[key];
            const isConnected = connectedPlatforms?.[key] !== false;

            return (
              <button
                key={key}
                className={clsx("platform", {
                  active: isActive,
                  "not-connected": !isConnected,
                })}
                onClick={() => setActiveTab(key)}
              >
                {isActive ? <ActiveIcon /> : <InactiveIcon />}
                <span className="platform-text">{label}</span>

                {isConnected ? (
                  <span
                    ref={(el) => (platformCheckRefs.current[key] = el)}
                    className={clsx("platform-check", { checked: isChecked })}
                    onClick={(e) => handlePlatformToggle(key, e)}
                  >
                    <TrueIcon />
                  </span>
                ) : (
                  <span
                    className="platform-warning-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      onPlatformNotConnectedClick?.(label);
                    }}
                  >
                    <SocialMediaWarningIcon />
                  </span>
                )}
              </button>
            );
          })}

          {LOCKED_PLATFORMS.map(({ key, label, ActiveIcon, InactiveIcon }) => {
            const isActive = activeTab === key;

            return (
              <button
                key={key}
                type="button"
                className={clsx("platform", {
                  active: isActive,
                  locked: true,
                })}
                onClick={() => {}}
                disabled
              >
                {isActive ? <ActiveIcon /> : <InactiveIcon />}
                <span className="platform-text">{label}</span>
                <span className="platform-lock">
                  <LockIcon2 />
                </span>
              </button>
            );
          })}
        </div>
      </div>

      <div className="platform-post-config">
        <div className="platform-post-config-top">
          <div>
            <div className="platform-post-title">{activeTab} post</div>
            <div className="platform-post-subtitle">
              Manage social media post for {activeTab}
            </div>
          </div>

          <PropertyPlatformPostMenuIcon
            disabled={
              updating ||
              //   !activePlatformKey ||
              !selectedPlatforms[activeTab] ||
              !isActivePlatformConnected
            }
            onPublishNow={openPlatformPostNow}
            onSchedulePost={openPlatformSchedule}
            onCancelSchedule={handlePlatformCancelSchedule}
            onRetryPost={() => {}}
            onViewErrors={() => {}}
          />
        </div>

        <div className="platform-post-meta">
          <div className="meta-item">
            <div className="meta-label">Status</div>

            {connectedPlatforms?.[activeTab] === false ? (
              <button
                type="button"
                className="status-pill status-pill--not-connected"
                onClick={() => onPlatformNotConnectedClick?.(activeTab)}
              >
                Account not connected
              </button>
            ) : (
              <div className={clsx("status-pill", statusConfig.variant)}>
                {statusConfig.label}
              </div>
            )}
          </div>

          <div className="meta-item">
            <div className="meta-label">Post link</div>
            {platformData?.permalink_url ? (
              <button
                type="button"
                className="show-post-link"
                onClick={() =>
                  window.open(
                    platformData.permalink_url,
                    "_blank",
                    "noopener,noreferrer",
                  )
                }
              >
                Show post
              </button>
            ) : (
              <div className="meta-value">-</div>
            )}
          </div>

          <div className="meta-item">
            <div className="meta-label">Scheduled for</div>
            <div className="meta-value">{platformScheduledFor}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(PostHeader);
